// extracted by mini-css-extract-plugin
export default {"blinking":"WorkoutType2_blinking__rm1y9","blink":"WorkoutType2_blink__8bNGr"};